var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiscontinued(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-discontinued_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 38 39",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-discontinued_svg__st0{fill:#213555}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-discontinued_svg__st0",
    d: "M19 38.5c-10.5 0-19-8.5-19-19S8.5.5 19 .5s19 8.5 19 19-8.5 19-19 19zm0-37c-9.9 0-18 8.1-18 18s8.1 18 18 18 18-8.1 18-18-8.1-18-18-18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-discontinued_svg__st0",
    d: "M28 26.5H10c-.2 0-.3-.1-.4-.3-.1-.2-.1-.4 0-.5l9-14.5c.2-.3.7-.3.8 0l9 14.5c.1.2.1.3 0 .5s-.2.3-.4.3zm-17.1-1h16.2L19 12.4l-8.1 13.1z"
  })));
}
export default SvgIconDiscontinued;